import localStorageTemplates from 'common/local-storage-templates';

export default error => {
  const { response } = error || {};
  const { data } = response || {};
  const { errMessage, errorMsg, message } = data || {};
  let errMsg = (errMessage && errMessage.errorMsg) || errorMsg;
  let messageExtracted = (errMessage && errMessage.message) || message;

  if (errMsg === undefined || errMsg.length <= 0) {
    if (messageExtracted && messageExtracted.length > 0) {
      errMsg = messageExtracted;
    } else {
      errMsg = 'Something went wrong. Please try again.';
    }
  } else if (errMsg === 'offline') {
    if (localStorage.getItem(localStorageTemplates.insentNetworkStatus) === 'offline')
      errMsg = 'noError';
    else errMsg = 'No internet Connection';
  }

  return errMsg;
};
